import { PROCESS } from "@/data/content";
import { Reveal, SectionLabel } from "./Reveal";

const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-24 md:py-36 bg-[#050A14]"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid md:grid-cols-12 gap-12 lg:gap-16">
        {/* Sticky heading */}
        <div className="md:col-span-4">
          <div className="md:sticky md:top-32">
            <SectionLabel testid="process-label">The Titan Method</SectionLabel>
            <h2 className="font-display font-bold tracking-tight text-white text-4xl md:text-5xl leading-[1.05]">
              A proven process, <span className="text-[#1E6BFF]">no guesswork.</span>
            </h2>
            <p className="mt-6 text-gray-400 leading-relaxed max-w-sm">
              Four deliberate chapters that take you from idea to a website that quietly
              sells for you around the clock.
            </p>
          </div>
        </div>

        {/* Scrolling steps */}
        <div className="md:col-span-8">
          {PROCESS.map((p, i) => (
            <Reveal key={p.no} delay={i * 0.05}>
              <div
                data-testid={`process-step-${p.no}`}
                className="group flex gap-6 md:gap-10 py-10 border-t border-white/10 first:border-t-0"
              >
                <span className="font-display font-black text-5xl md:text-7xl text-outline-blue group-hover:text-[#1E6BFF] transition-colors duration-500 leading-none shrink-0">
                  {p.no}
                </span>
                <div className="pt-1">
                  <h3 className="font-display font-semibold text-2xl md:text-3xl text-white mb-3">
                    {p.title}
                  </h3>
                  <p className="text-gray-400 text-base md:text-lg leading-relaxed max-w-xl">
                    {p.desc}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
